module.exports = __webpack_public_path__ + "img/footballBanner_1248.99e4d32a.png";